import { useEffect, useMemo, useState } from "react";
import PageHero from "@/components/PageHero";
import api from "@/lib/api";
import { GraduationCap, Phone } from "lucide-react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";

export default function CoachesPage() {
  const [coaches, setCoaches] = useState([]);
  const [district, setDistrict] = useState("all");
  useEffect(() => { api.get("/coaches").then((r) => setCoaches(r.data)); }, []);

  const districts = useMemo(() => Array.from(new Set(coaches.map((c) => c.district))).sort(), [coaches]);
  const filtered = district === "all" ? coaches : coaches.filter((c) => c.district === district);

  return (
    <div data-testid="coaches-page">
      <PageHero eyebrow="Certified experts" title="COACHES" subtitle="Meet our AIPA & IPTPA certified coaches."
        image="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=1800" />
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 mb-8">
          <div className="text-[10px] font-bold uppercase tracking-widest text-jpa-primary">Filter by district</div>
          <Select value={district} onValueChange={setDistrict}>
            <SelectTrigger data-testid="coaches-district-filter" className="rounded-sm w-full sm:w-64"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All districts ({coaches.length})</SelectItem>
              {districts.map((d) => (
                <SelectItem key={d} value={d}>{d} ({coaches.filter((c) => c.district === d).length})</SelectItem>
              ))}
            </SelectContent>
          </Select>
          <div className="text-sm text-jpa-muted">Showing <b>{filtered.length}</b> {filtered.length === 1 ? "coach" : "coaches"}</div>
        </div>

        {filtered.length === 0 ? (
          <div className="py-16 text-center text-jpa-muted">No coaches in this district yet.</div>
        ) : (
          <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {filtered.map((c) => (
              <div key={c.id} data-testid={`coach-card-${c.id}`} className="border border-jpa-border overflow-hidden bg-white group">
                <div className="aspect-[3/4] overflow-hidden bg-jpa-surface">
                  {c.image_url && <img src={c.image_url} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform" />}
                </div>
                <div className="p-5">
                  <div className="text-[10px] font-bold uppercase tracking-widest text-jpa-primary flex items-center gap-1">
                    <GraduationCap className="w-3.5 h-3.5" /> {c.certification}
                  </div>
                  <h3 className="font-display text-2xl tracking-wider mt-1">{c.name}</h3>
                  <div className="text-sm text-jpa-muted mt-1">{c.district} • {c.experience_years} yrs</div>
                  {c.phone && <div className="mt-3 flex items-center gap-2 text-sm text-jpa-primary"><Phone className="w-4 h-4" /> {c.phone}</div>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
